import axios from "@/api/index";
let method = 'GET';
/*短信发送接口*/
export const sendsms=data=>axios.post('/register/common/sendsms',data)
/*验证短信接口*/
export const verifySms=data=>axios.post('/register/common/verifySms',data)
/*项目申报之免费评估,资金申请*/
export const applicationForfunding=data=>axios.post('/register/commonss/applicationForfunding',data)
/*获取已申报信息*/
export const getApplicationInfo=data=>axios.post('/register/commonss/getApplicationInfo',data)
/*关于帮企网之检查更新*/
export const getNewVersion=data=>axios.get('/register/commonss/getNewVersion',data)
/*获取所有政策地区*/
export const getPolicyArea=data=>axios.get('/register/commonss/getPolicyArea',data)
/*项目申报之补贴政策（政策速递）*/
export const getSubsidyPoilcy=data=>axios.post('/register/commonss/getSubsidyPoilcy',data)
/*关于帮企网之更新日志*/
export const getupdateVersionLog=data=>axios.get('/register/commonss/getupdateVersionLog',data)
/*添加意见反馈*/
export const saveFeedBack=data=>axios.post('/register/commonss/saveFeedBack',data)
/*获取省会城市信息*/
export const getProvincialCapitalCityInformation=data=>axios.post('/home/restPlatformHome/getProvincialCapitalCityInformation',data)
/*获取定位信息*/
export function getCitySn(city) {
    return axios.get("https://restapi.amap.com/v3/geocode/geo?address="+city+"&key=720cf4307bf10f3c7629bca91b7cd4f5&address="+city)
}
/*发送邮箱验证码*/
export const sendEmailVerCode=data=>axios.post('/order/personalCenter/sendEmailVerCode',data)
/*校验邮箱验证码*/
export const checkEmailVerCode=data=>axios.post('/order/personalCenter/checkEmailVerCode',data)
/*绑定邮箱*/
export const bindMailbox=data=>axios.post('/order/personalCenter/bindMailbox',data)
/*解绑邮箱*/
export const untieMailbox=data=>axios.post('/order/personalCenter/untieMailbox',data)
/*登录保护状态*/
export const loginProtectionStatus=data=>axios.post('/order/personalCenter/loginProtectionStatus',data)
/*修改登录保护*/
export const updLoginProtection=data=>axios.post('/order/personalCenter/updLoginProtection',data)